import React from 'react'
import { connect, ConnectedProps } from 'react-redux'

import { appActions } from '../../redux'
import { PageControlButtons } from '../'
import { ReduxState } from '../../types'
import messages from '../../i18n'

interface Props extends ConnectedProps<typeof connector> {
  formName: string
}

export const PrefillFormButton = ({ appReady, formName, isDevelopment, prefillForm }: Props) =>
  isDevelopment && appReady ? (
    <PageControlButtons
      onSubmit={() => {
        prefillForm(formName)
      }}
      submitMessage={messages.common.prefill}
      testId="prefill"
    />
  ) : null

const connector = connect(
  (state: ReduxState) => ({
    appReady: state.app.appReady,
    isDevelopment: state.app.isDevelopment,
  }),
  {
    prefillForm: appActions.prefillForm,
  }
)

export default connector(PrefillFormButton)
